import Axios from 'axios';
import localforage from 'localforage';
import memoryDriver from 'localforage-memoryStorageDriver';
import { setup } from 'axios-cache-adapter';

import { checkAccessToken } from './auth';

// Configura `localforage` e retorna uma instância do `axios` com `axios-cache-adapter`
export async function configure() {
  // Registre o `memoryDriver` customizado para` localforage`
  await localforage.defineDriver(memoryDriver);

  // Cria uma instância do `localforage`
  const store = localforage.createInstance({
    // Lista os drivers usados
    driver: [
      localforage.INDEXEDDB,
      localforage.LOCALSTORAGE,
      memoryDriver._driver,
    ],
    // Adiciona prefixo em todas as chaves de armazenamento para evitar conflitos
    name: 'my-cache',
  });

  return setup({
    baseURL: process.env.REACT_APP_BASE_URL,
    cache: {
      maxAge: 15 * 60 * 1000,
      store, // Adicionar a instância do `localforage` no armazenamento do `axios-cache-adapter`
    },
  });
}

const cache = setup({
  maxAge: 15 * 60 * 1000,
});

const api = Axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  adapter: cache.adapter,
});

const routes = [
  '/users/forgotpass',
  '/users/resetpass',
  '/users/invite',
  '/users/confirm',
  '/properties/userAndDomain',
  '/users/new-user',
];

api.interceptors.request.use(
  async (req) => {
    req.params = {
      ...(req.params || {}),
    };
    const token = await checkAccessToken();
    if (token !== null) {
      req.headers.Authorization = `Bearer ${token}`;
      return req;
    }
    if (routes.includes(req.url)) {
      return req;
    }

    throw new Axios.Cancel('Operação cancelada');
  },
  (err) => Promise.reject(err)
);

export default api;
